var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.77,
    height: 16.846,
    viewBox: "0 0 26.77 16.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_625_",
    transform: "translate(0.226 0.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_567_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_105_",
    d: "M29.134,122.446a12.144,12.144,0,0,1-5.153-1.233,19.566,19.566,0,0,1-4.09-2.642,25.007,25.007,0,0,1-3.739-3.821.872.872,0,0,1,0-1.053,25.007,25.007,0,0,1,3.739-3.821,19.565,19.565,0,0,1,4.09-2.642A12.144,12.144,0,0,1,29.134,106a12.144,12.144,0,0,1,5.153,1.233,19.565,19.565,0,0,1,4.09,2.642,24.7,24.7,0,0,1,3.739,3.821.872.872,0,0,1,0,1.053,25.006,25.006,0,0,1-3.739,3.821,19.566,19.566,0,0,1-4.09,2.642A12.144,12.144,0,0,1,29.134,122.446Zm-11.151-8.223c1.376,1.628,5.921,6.469,11.151,6.469s9.775-4.841,11.151-6.469c-1.376-1.628-5.921-6.469-11.151-6.469S19.359,112.6,17.983,114.223Z",
    transform: "translate(-15.975 -106)",
    fill: "#fff",
    stroke: "#e73758",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_568_",
    transform: "translate(9.211 4.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_102_",
    d: "M187.947,191.894a3.947,3.947,0,1,1,3.947-3.947A3.952,3.952,0,0,1,187.947,191.894Zm0-6.14a2.193,2.193,0,1,0,2.193,2.193A2.192,2.192,0,0,0,187.947,185.754Z",
    transform: "translate(-184 -184)",
    fill: "#fff",
    stroke: "#e73758",
    strokeWidth: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.a98df95d3de59e1e3bfed8f963724087.svg";
export { ForwardRef as ReactComponent };